import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { serviceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { toasts } from '@/utils/toasts';

export const editService = (
  data: serviceTypes.EditServiceData
): Promise<{ service: serviceTypes.Service }> => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/services/${_id}`, { data: dataWithoutId });
};

type EditServiceOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof editService>;
};

export function useEditService({ config = {}, department, onSuccess }: EditServiceOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['services', department]);
      toasts.loadingToast.success('edit-service', 'Service updated successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('edit-service', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-service', 'Updating service...');
      config.onMutate?.(...args);
    },
    mutationFn: editService,
  });
}
